import { errorCodes, getUserFriendlyErrorMessage } from '../../utils/errormessages'
import { LOGOUT } from '../../app/authState'
import {
  ERROR,
  GET_ADDITIONAL_CONSENT_FORMS,
  GET_ADDITIONAL_CONSENT_FORMS_ERROR,
  GET_ADDITIONAL_CONSENT_FORMS_SUCCESS,
  GET_INTAKE_FORMS,
  GET_INTAKE_FORMS_ERROR,
  GET_INTAKE_FORMS_SUCCESS,
  PUBLISH_SERVICE,
  PUBLISH_SERVICE_ERROR,
  PUBLISH_SERVICE_SUCCESS,
  RESET,
  TOGGLE_CANCEL_PRESSED,
} from './NewServiceConstants'

const initialState = {
  loading: false,
  publishSuccess: false,
  intakeForms: [],
  additionalConsentFormsOptions: [],
  defaultServerErrorMessage: '',
  cancelPressed: false,
}

export default function newServiceReducer(state = initialState, action = {}) {
  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  switch (action.type) {
    case PUBLISH_SERVICE:
      return {
        ...state,
        loading: true,
        publishSuccess: false,
      }
    case GET_INTAKE_FORMS:
    case GET_ADDITIONAL_CONSENT_FORMS:
      return {
        ...state,
        loading: true,
      }
    case GET_INTAKE_FORMS_SUCCESS:
      return {
        ...state,
        loading: false,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        intakeForms: action.payload.IntakeForms || [],
      }
    case GET_ADDITIONAL_CONSENT_FORMS_SUCCESS:
      return {
        ...state,
        loading: false,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        additionalConsentFormsOptions: action.payload,
      }
    case PUBLISH_SERVICE_SUCCESS:
      return {
        ...state,
        loading: false,
        publishSuccess: true,
      }
    case PUBLISH_SERVICE_ERROR:
    case GET_INTAKE_FORMS_ERROR:
    case GET_ADDITIONAL_CONSENT_FORMS_ERROR:
    case ERROR: {
      let message = ''
      let defaultServerErrorMessage = ''
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      if (action.payload.UserFriendlyErrorCode || action.payload.UserFriendlyErrorCode === '') {
        message =
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          action.payload.UserFriendlyErrorCode ?
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            getUserFriendlyErrorMessage(action.payload.UserFriendlyErrorCode, null, action.payload.extra)
          : ''
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        defaultServerErrorMessage = action.payload.UserFriendlyErrorCode ? action.payload : ''
      } else {
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        switch (action.payload.ErrorCode) {
          case 'NameNotValid':
            message = getUserFriendlyErrorMessage(errorCodes.FIELD_REQUIRED, null, 'Service Type')
            break
          case 'DescriptionNotValid':
            message = getUserFriendlyErrorMessage(errorCodes.FIELD_REQUIRED, null, 'Service description')
            break
          case 'VisitTypeIntakeFormCountNotValid':
            message = getUserFriendlyErrorMessage(errorCodes.FIELD_REQUIRED, null, 'Intake forms')
            break
          case 'VisitTypeConsentFormCountNotValid':
            message = getUserFriendlyErrorMessage(errorCodes.FIELD_REQUIRED, null, 'Consent forms')
            break
          case 'VisitTypeCostNotValid':
          case 'VisitTypeNameNotValid':
          case 'VisitTypeCancellationFeeNotValid':
            message = getUserFriendlyErrorMessage(errorCodes.FILL_ALL_FIELDS)
            break
          case 'NameNotUnique':
            message = getUserFriendlyErrorMessage(errorCodes.NAME_ALREADY_EXISTS, null, 'Service type')
            break
          case 'InternalServerError':
            message = getUserFriendlyErrorMessage(errorCodes.DEFAULT)
            break
          default:
            message = getUserFriendlyErrorMessage(errorCodes.DEFAULT)
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            defaultServerErrorMessage = action.payload
            break
        }
      }
      return {
        ...state,
        error: message,
        loading: false,
        defaultServerErrorMessage,
      }
    }
    case RESET:
      return {
        ...initialState,
        intakeForms: state.intakeForms,
        additionalConsentFormsOptions: state.additionalConsentFormsOptions,
      }
    case TOGGLE_CANCEL_PRESSED:
      return {
        ...state,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        cancelPressed: action.payload,
      }
    case LOGOUT:
      return {
        ...initialState,
      }
    default:
      return state
  }
}
